l
<template>
	<div>
		<!--<headlink></headlink>-->
		 <headlink v-if="parent == '0'"></headlink>
        <headlink1 v-if="parent == '1'"></headlink1>

		<div class="container ui-flex ui-flex-pack-center">

			<div class="zidingyileft ui-border-l">
				<div class="ui-form ui-border-t">
					<div v-if="len3 != 0" v-on:click="getEqList(3,1)" id="eq3" class="pointer ui-form-item ui-form-item-link ui-border-b ">
						一路设备
					</div>
					<div v-if="len1 != 0" v-on:click="getEqList(1,1)" id="eq1" class="pointer ui-form-item ui-form-item-link ui-border-b ">
						二路设备
					</div>
					<div v-if="len4 != 0"  v-on:click="getEqList(4,1)" id="eq4" class="pointer ui-form-item ui-form-item-link ui-border-b active">
						配电箱设备
					</div>
					<div  v-if="len2 != 0" v-on:click="getEqList(2,1)" id="eq2" class="pointer ui-form-item ui-form-item-link ui-border-b">
						四路设备
					</div>
					<div v-if="len6 != 0"  v-on:click="getEqList(6,1)" id="eq6" class="pointer ui-form-item ui-form-item-link ui-border-b">
						单路定位设备
					</div>
					<div v-if="len5 != 0"  v-on:click="getEqList(5,1)" id="eq5" class="pointer ui-form-item ui-form-item-link ui-border-b">
						二路定位设备
					</div>
					<div v-if="len7 != 0"  v-on:click="getEqList(7,1)" id="eq7" class="pointer ui-form-item ui-form-item-link ui-border-b">
						正反转设备
					</div>
					<div v-if="len11 != 0"  v-on:click="getEqList(11,1)" id="eq11" class="pointer ui-form-item ui-form-item-link ui-border-b">
						四路定位设备
					</div>
					<div v-if="len9 != 0"  v-on:click="getEqList(9,1)" id="eq9" class="pointer ui-form-item ui-form-item-link ui-border-b">
						二路定时设备
					</div>
					<div v-if="len10 != 0" v-on:click="getEqList(10,1)" id="eq10" class="pointer ui-form-item ui-form-item-link ui-border-b">
						四路定时设备
					</div>
					<div v-if="len8 != 0"  v-on:click="getEqList(8,1)" id="eq8" class="pointer ui-form-item ui-form-item-link ui-border-b">
						八路定时设备
					</div>
				</div>

			</div>
			<div class="zhong">
              <div v-if="eqType==4" class="ui-flex ui-flex-pack-center mass-center">
					<div v-on:mousedown="gett(3,1)">
						<img id="kaiqi" src="/static/img/qktanqi.png" class="pointer" />
						<center>
							<p align="center">启动</p>
						</center>
					</div>
					<div v-on:mousedown="gett(4,1)"  class="left-padding">
						<img id="guanbi" src="/static/img/qgtanqi.png" class="pointer" />
						<center>
							<p align="center">停止</p>
						</center>
					</div>
				</div>
				<div v-if="eqType!=4" class="ui-flex ui-flex-pack-center mass-center">
					<div v-on:mousedown="get(1,0,2)" v-on:mouseup="get(1,0,1)">
						<img id="kaiqi" src="/static/img/qktanqi.png" class="pointer" />
						<center>
							<p align="center">全开</p>
						</center>
					</div>
					<div v-on:mousedown="out(2,0,2)" v-on:mouseup="out(2,0,1)" class="left-padding">
						<img id="guanbi" src="/static/img/qgtanqi.png" class="pointer" />
						<center>
							<p align="center">全关</p>
						</center>
					</div>
				</div>
				<div class="mass-center-2 ui-flex ui-flex-ver ui-flex-align-start">
					<div v-show="eqType>=1 && eqType!=4" style="width:100%">
						<div class="column1">第一路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,1)">开</button>
							<button class="button-type red" v-on:click="gett(4,1)">关</button>
							<button class="button-type" v-on:click="gett(5,1)">点动</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(6,1)">周期定时</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(7,1)">单次定时</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(8,1)">周期循环</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(9,1)">循环定时</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(10,1)">立即循环</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(11,1)">取消定时</button>
							
						</div>
					</div>
					<div v-if="eqType !=3 && eqType !=6 && eqType !=4" style="width:100%">
						<div class="column1">第二路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,2)">开</button>
							<button class="button-type red" v-on:click="gett(4,2)">关</button>
							<button class="button-type" v-on:click="gett(5,2)">点动</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(6,2)">周期定时</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(7,2)">单次定时</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(8,2)">周期循环</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(9,2)">循环定时</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(10,2)">立即循环</button>
							<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(11,2)">取消定时</button>
							
						</div>
					</div>
					<div v-show="eqType==2 || eqType==11 || eqType==10 || eqType==8 " style="width:100%">
						<div class="column1">第三路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,3)">开</button>
							<button class="button-type red" v-on:click="gett(4,3)">关</button>
							<button class="button-type" v-on:click="gett(5,3)">点动</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(6,3)">周期定时</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(7,3)">单次定时</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(8,3)">周期循环</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(9,3)">循环定时</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(10,3)">立即循环</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(11,3)">取消定时</button>
							
						</div>
						<div class="column1">第四路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,4)">开</button>
							<button class="button-type red" v-on:click="gett(4,4)">关</button>
							<button class="button-type" v-on:click="gett(5,4)">点动</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(6,4)">周期定时</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(7,4)">单次定时</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(8,4)">周期循环</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(9,4)">循环定时</button>
							<button v-if="eqType==8 ||  eqType==10" class="button-type" v-on:click="gett(10,4)">立即循环</button>
							<button v-if="eqType==8 || eqType==10" class="button-type" v-on:click="gett(11,4)">取消定时</button>
							
						</div>
					</div>

					<div v-show="eqType==8" style="width:100%">
						<div class="column1">第五路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,5)">开</button>
							<button class="button-type red" v-on:click="gett(4,5)">关</button>
							<button class="button-type" v-on:click="gett(5,5)">点动</button>
							<button class="button-type" v-on:click="gett(6,5)">周期定时</button>
							<button class="button-type" v-on:click="gett(7,5)">单次定时</button>
							<button class="button-type" v-on:click="gett(8,5)">周期循环</button>
							<button class="button-type" v-on:click="gett(9,5)">循环定时</button>
							<button class="button-type" v-on:click="gett(10,5)">立即循环</button>
							<button class="button-type" v-on:click="gett(11,5)">取消定时</button>
							
						</div>
						<div class="column1">第六路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,6)">开</button>
							<button class="button-type red" v-on:click="gett(4,6)">关</button>
							<button class="button-type" v-on:click="gett(5,6)">点动</button>
							<button class="button-type" v-on:click="gett(6,6)">周期定时</button>
							<button class="button-type" v-on:click="gett(7,6)">单次定时</button>
							<button class="button-type" v-on:click="gett(8,6)">周期循环</button>
							<button class="button-type" v-on:click="gett(9,6)">循环定时</button>
							<button class="button-type" v-on:click="gett(10,6)">立即循环</button>
							<button class="button-type" v-on:click="gett(11,6)">取消定时</button>
							
						</div>
						<div class="column1">第七路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,7)">开</button>
							<button class="button-type red" v-on:click="gett(4,7)">关</button>
							<button class="button-type" v-on:click="gett(5,7)">点动</button>
							<button class="button-type" v-on:click="gett(6,7)">周期定时</button>
							<button class="button-type" v-on:click="gett(7,7)">单次定时</button>
							<button class="button-type" v-on:click="gett(8,7)">周期循环</button>
							<button class="button-type" v-on:click="gett(9,7)">循环定时</button>
							<button class="button-type" v-on:click="gett(10,7)">立即循环</button>
							<button class="button-type" v-on:click="gett(11,7)">取消定时</button>
							
						</div>
						<div class="column1">第八路</div>
						<div class="column2 ui-border-b">
							<button class="button-type green" v-on:click="gett(3,8)">开</button>
							<button class="button-type red" v-on:click="gett(4,8)">关</button>
							<button class="button-type" v-on:click="gett(5,8)">点动</button>
							<button class="button-type" v-on:click="gett(6,8)">周期定时</button>
							<button class="button-type" v-on:click="gett(7,8)">单次定时</button>
							<button class="button-type" v-on:click="gett(8,8)">周期循环</button>
							<button class="button-type" v-on:click="gett(9,8)">循环定时</button>
							<button class="button-type" v-on:click="gett(10,8)">立即循环</button>
							<button class="button-type" v-on:click="gett(11,8)">取消定时</button>
							
						</div>
					</div>

				</div>
                    
                    <div align="center">
                    	<button type="button" class="btn btn-primary btn-lg btn-block" v-if="eqType==8 || eqType==9 || eqType==10"  v-on:click="gett(12,2)">矫正时间</button>     
                    </div>
                
                    
                    
                    
                    
                    
				<div id="ljxhdiv" style="display: none;">
					<center>
						<div>
							<center>
								<div align="center" class="jz">
									<h3><b>开启时长 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="ljxhontime" value=""></b></h3></div>
							</center>
						</div><br>
						<div>
							<center>
								<div align="center" id="jz">
									<h3><b>关闭时长 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="ljxhofftime" value=""></b></h3></div>
							</center>
						</div><br>

						<h3>
      	
      		   
                 <input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="ljxh" />
                 
      	
        </center>
    </div>     
        	<div id="zqxhdiv" style="display: none;">
			<center>
  <div>
			<div><h3><b>开始时间 :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="stime" value=""></b></h3></div>

			</div><br>
			<div>
				<div>
					<h3><b>結束时间 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="etime" value=""></b></h3></div>

			</div><br>
			<div>
				<div>
					<h3><b>开启时长 :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="ontime" value=""></b></h3></div>

			</div><br>
			<div>
				<div>
					<h3><b>关闭时长 :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="offtime" value=""></b></h3></div>

			</div><br>

			<table cellpadding="10px" cellspacing="10px">
				<tr>
					<td>
						<h3>重复&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3></td>
					<td>
						<h3> 
                       
             

				<ul>

	<li><input type="checkbox"  name="zqxh"   value="1" />星期一</li>

	<li><input type="checkbox" name="zqxh" value="2" />星期二</li>

	<li><input type="checkbox" name="zqxh"  value="3" />星期三</li>

	<li><input type="checkbox"  name="zqxh"  value="4" />星期四</li>

	<li><input type="checkbox" name="zqxh"   value="5" />星期五</li>

	<li><input type="checkbox"  name="zqxh"  value="6" />星期六</li>

	<li><input type="checkbox"  name="zqxh"  value="7" />星期日</li>

</ul>

	
	
	
 </h3> </td>
				</tr>
			</table>

			<h3>
      	
      		 
                 <input type="button" value="确定"  class="je-btn je-bg-red je-rdu" id="zqxh" />
               
        </center>
    </div>  
        	
        <div id="zqdsdiv" style="display: none;">    
	
	
	<center>
	<div class="alert alert-success alert-dismissable" id="ok" style="display: none;">
         
         
        </div>
      <div id="no" style="display: none;" class="alert alert-danger alert-dismissable">

			</div>
        
        
        
	</center>
	<center>
	
		
	 
		  <div>
			<div><h3><b>时间: &nbsp;&nbsp;<input  class="dateinput dateicon" type="text"  id="zqdsstime" value=""></b></h3></div>
	</div>

	<table cellpadding="10px" cellspacing="10px">
		<tr>
			<td>
				<h3>重复&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3></td>
			<td>
				<h3> 
  
  <ul>

	<li><input type="checkbox"  name="zqds"   value="1" />星期一</li>

	<li><input type="checkbox"  name="zqds" value="2" />星期二</li>

	<li><input type="checkbox"  name="zqds"  value="3" />星期三</li>

	<li><input type="checkbox"   name="zqds"  value="4" />星期四</li>

	<li><input type="checkbox"  name="zqds"   value="5" />星期五</li>

	<li><input type="checkbox"   name="zqds"  value="6" />星期六</li>

	<li><input type="checkbox"   name="zqds" value="7" />星期日</li>

 </ul>
 
	 
	
	
 </h3> </td>
		</tr>
	</table>

	<h3><input  type="radio" name="kg" checked="checked" value="1"/>开
             
                  <input  type="radio" name="kg" value="0" />关</h3>
	<div><input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="zqds" />
	</div>

	</center>
	</div>

	<div id="dcdsdiv" style="display: none;">
		<center>

			<div>
				<div>
					<h3><b>日期 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text" id="riqi"></b></h3> </div>
			</div><br>
			<div>
				<div>
					<h3><b>时间  :  &nbsp;&nbsp;<input class="dateinput dateicon" type="text" id="dcdsstime" value=""></b></h3> </div>
			</div><br>

			<h3><input  type="radio" name="dcds" checked="checked" value="1"/>开    
                   <input  type="radio" name="dcds" value="0" />关 </h3>
			<div>
				<input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="dcds" />

			</div>

		</center>
	</div>

	<div id="xhdsdiv" style="display: none;">
		<center>

			<div>
				<div>
					<h3><b>开始时间 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="xhdsstime" value=""></b></h3></div>

			</div><br>
			<div>
				<div>
					<h3><b>结束时间 : &nbsp;&nbsp;<input class="dateinput dateicon" type="text"  id="xhdsetime" value=""></b></h3></div>

			</div><br>

			<table cellpadding="10px" cellspacing="10px">
				<tr>
					<td>
						<h3>重复&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3></td>
					<td>
						<h3> 
  
	
	<ul>

	<li><input type="checkbox"  name="xhds"   value="1" />星期一</li>

	<li><input type="checkbox" name="xhds" value="2" />星期二</li>

	<li><input type="checkbox" name="xhds"  value="3" />星期三</li>

	<li><input type="checkbox"  name="xhds"  value="4" />星期四</li>

	<li><input type="checkbox" name="xhds"   value="5" />星期五</li>

	<li><input type="checkbox"  name="xhds"  value="6" />星期六</li>

	<li><input type="checkbox"  name="xhds"  value="7" />星期日</li>

 </ul>
	
	
	
 </h3> </td>
				</tr>
			</table>

			<h3>
      	
      		  
                 <input type="button" value="确定" class="je-btn je-bg-red je-rdu" id="xhds" />
     </center>
    </div> 	
        	
        	
        	
        	
        	
        	
  </div>
        	
        	<div class="right-container"  >
        	<!--	<div style="text-align:center;color:#369CDB" ><span v-on:click="getEqListPage(pageSize-1)" >< 上一页</span><span>&nbsp&nbsp&nbsp&nbsp{{pageSize}}&nbsp&nbsp&nbsp&nbsp</span><span v-on:click="getEqListPage(pageSize+1)" >下一页 ></span></div>-->
        		<div id="treeview1" class="">
        			
        		</div>	
				
				<!--<div>
				<button v-if="eqType==8 || eqType==9 || eqType==10" class="button-type" v-on:click="gett(12,2)">矫正时间</button>
				
			</div>-->
        
        
        </div>
       
        
        
        
	</div>
</template>

<script>
var count = 0;
var num = 0;
var ajaxFlag = 0;
var tree = new Array();
var $checkableTree;

	  function initTree(){
		   $checkableTree = $('#treeview1').treeview({
        	color: "#369CDB",
        	backColor: "#E5E5E5",
            onhoverColor: "#E5E5E5",
           borderColor: "#E5E5E5",
           selectedColor:"#369CDB",
           showCheckbox: true,
           data: tree,
       
       //选中
       onNodeChecked: function(event, node) {
          	if("全选"==node.text){
	          	$checkableTree.treeview('checkAll');
	          }
          },
          //选中
          onNodeUnchecked: function (event, node) {
			if("全选"==node.text){
	          	$checkableTree.treeview('uncheckAll');
	          }
          },
          onNodeSelected: function(event, node) {
          	//var aaa = $checkableTree.treeview('search', [ node.text, { ignoreCase: false, exactMatch: false } ]);
	          if("全选"==node.text){
	          	//全选中	
	          	$checkableTree.treeview('checkAll');
	          }else{
	          	//单选中
	          	$checkableTree.treeview('checkNode', node.nodeId);
	          }
            },
            onNodeUnselected: function (event, node) {
            	//var aaa = $checkableTree.treeview('search', [ node.text, { ignoreCase: false, exactMatch: false } ]);
            if("全选"==node.text){
            	//全取消
	          	$checkableTree.treeview('uncheckAll');
	          }else{
	          	//单取消
	          	$checkableTree.treeview('uncheckNode', node.nodeId);
	          }
            }
        });
           

	  }

  //引入导航栏这个组件
  import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'
  export default {
  name: 'addDevice',
  data () {
    return {
    	eqList:[],
    	len1:0,
    	len2:0,
    	len3:0,
    	len4:0,
    	len5:0,
    	len6:0,
    	len7:0,
    	len8:0,
    	len9:0,
    	len10:0,
    	len11:0,
    	
		//当前页数
		pageSize:1,
		pageNum:20,
		totoCount:0,
		eqType:"4",
		parent: "0"

    }
  },
  methods:{
  	
      pichuli(state,no,node){
      	
      
      const history = window.sessionStorage;
				var uid = history.getItem("user");
				var eqId = node.tags[0].eqId;
     
               var Type;
                 count ++;
       function getData() {

	var json = {
		"serviceCode": "1018",
		"uId": uid,
		"eqId": eqId
		
	}
	return json;
}
       
       
            if (state == "10") {
            	Type = "E";
                $("#ljxhdiv").show();
            	$("#zqdsdiv").hide();
            	$("#dcdsdiv").hide();
            	$("#zqxhdiv").hide();
            	$("#xhdsdiv").hide();
            $("#ljxh").click(function(){
             	
             
            var ontime = $("#ljxhontime").val();
			var offtime = $("#ljxhofftime").val();
            //g 全局替换，
            var rs = new RegExp(":", "g");
             //把冒号替换为空字符串
			ontime = ontime.replace(rs, "");
			offtime = offtime.replace(rs, "");
                   
                         
                               $.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getData()),
					dataType: 'json',
					success: function(response) {
						console.log(response)
                        this.eqObject = response;
						this.eqType = response.eqType;
						var citId = "";
						var citDdTime1 = "";
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									
								}
							}else{
								list2[i] = cit;
							}
						}
                                
                                
                                
                                $.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(a()),
										dataType: 'json',
										success: function(response) {
											console.log(response)
										if(response.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
									
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
									 
								}
							}	
							
							
							initTree()
							if(count==num){
								console.log("放开");
								
								count = 0;
								num = 0;
								ajaxFlag =0;
								
							
							}
							
							}
									});   
                            
             function a() {

	var json = {
		"serviceCode":"1025",
		"uId": uid,
"eqId": eqId,
"citIds": citId,
"type": Type,
"openLength": ontime,
"closeLength": offtime

}
return json;
}               
   }                         
 })
                             
             }  )
            
         
            
           }  else if (state=="11") {
             	$("#ljxhdiv").hide();
            	$("#zqdsdiv").hide();
            	$("#dcdsdiv").hide();
            	$("#zqxhdiv").hide();
            	$("#xhdsdiv").hide();
            	Type="F";
            	 	$.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getData()),
					dataType: 'json',
					success: function(response) {
						console.log(response)
                        this.eqObject = response;
						this.eqType = response.eqType;
						var citId = "";
						var citDdTime1 = "";
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									
								}
							}else{
								list2[i] = cit;
							}
						}
                  $.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(shi()),
										dataType: 'json',
										success: function(response) {
											console.log(response)
										if(response.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}	
							
							//num 设备数量
							initTree()
							if(count==num){
								console.log("放开");
								count = 0;
								num = 0;
								ajaxFlag =0;
								
							}
							
							}
									});   
                            
             function shi() {

	var json = {
		"serviceCode":"1025",
		"uId": uid,
"eqId": eqId,
"citIds": citId,
"type": Type


}
return json;
}               
                            
}
 })      	
       } else if (state=="6") {
       	Type="A";
       	        $("#ljxhdiv").hide();
            	$("#zqdsdiv").show();
            	$("#dcdsdiv").hide();
            	$("#zqxhdiv").hide();
            	$("#xhdsdiv").hide();
            	
            	
            	
            	
       	    $("#zqds").click(function(){
       	    $.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getData()),
					dataType: 'json',
					success: function(response) {
						console.log(response)
                        this.eqObject = response;
						this.eqType = response.eqType;
						var citId = "";
						var citDdTime1 = "";
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									
								}
							}else{
								list2[i] = cit;
							}
						}
				 
                         $.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(a()),
										dataType: 'json',
										success: function(response) {
											console.log(response)
										if(response.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}	
							
							
							initTree()
							if(count==num){
								console.log("放开");
count = 0;
num = 0;
ajaxFlag = 0;

}

}
});

function a() {
	var on_off = $('input[name="kg"]:checked').val();

	var zqdsweek = [];
	$('input[name=zqds]:checked').each(function() {

		zqdsweek.push($(this).val());

	});

	var stime = $("#zqdsstime").val();
	var rs = new RegExp(":", "g");
	stime = stime.replace(rs, "");

	var json = {"serviceCode":"1025",
		"uId": uid,
"eqId": eqId,
"citIds": citId,
"type": Type,
"weeks": zqdsweek.toString(),
"on_off": on_off,
"startTime": stime

}
return json;
}               

    }
					})
					})
       	    
       	    
       	
       	
       	
       	
       	
       	
       } else if (state=="7") {
       	 Type="B";
       	 $("#ljxhdiv").hide();
            	$("#zqdsdiv").hide();
            	$("#dcdsdiv").show();
            	$("#zqxhdiv").hide();
            	$("#xhdsdiv").hide();
       	   $("#dcds").click(function(){
       	             $.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getData()),
					dataType: 'json',
					success: function(response) {
						console.log(response)
                        this.eqObject = response;
						this.eqType = response.eqType;
						var citId = "";
						var citDdTime1 = "";
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									
								}
							}else{
								list2[i] = cit;
							}
						}
				 $.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(a()),
										dataType: 'json',
										success: function(response) {
											console.log(response)
										if(response.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}	
							
							
							initTree()
							if(count==num){
								console.log("放开");
count = 0;
num = 0;
ajaxFlag = 0;

}

}
});

function a() {
	var on_off = $('input[name="dcds"]:checked').val();
										var stime = $("#dcdsstime").val();
										var riqi = $("#riqi").val();
										var re = new RegExp("/", "g");
										var rs = new RegExp(":", "g");
										riqi = riqi.replace(re, "");

										stime = stime.replace(rs, "");

	var json = {"serviceCode":"1025",
		"uId": uid,
"eqId": eqId,
"citIds": citId,
"type": Type,
"on_off": on_off,
"date": riqi,
"startTime": stime

}
return json;
}               
  	
     }})  	   	
       	   })
       	
       	
       	
       }else if (state=="8") {
       	Type="C";
       	 $("#ljxhdiv").hide();
            	$("#zqdsdiv").hide();
            	$("#dcdsdiv").hide();
            	$("#zqxhdiv").show();
            	$("#xhdsdiv").hide();
            	$("#zqxh").click(function(){
            		
            		 	   
				//首先查询哪路
				$.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getData()),
					dataType: 'json',
					success: function(response) {
						console.log(response)
                        this.eqObject = response;
						this.eqType = response.eqType;
						var citId = "";
						var citDdTime1 = "";
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									
								}
							}else{
								list2[i] = cit;
							}
						}
                            
                         $.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(a()),
										dataType: 'json',
										success: function(response) {
											console.log(response)
										if(response.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}	
							
							
							initTree()
							if(count==num){
								console.log("放开");
count = 0;
num = 0;
ajaxFlag = 0;

}

}
});

function a() {
var etime = $("#etime").val();
										var stime = $("#stime").val();
										var ontime = $("#ontime").val();
										var offtime = $("#offtime").val();
										

										var rs = new RegExp(":", "g");

										etime = etime.replace(rs, "");
										stime = stime.replace(rs, "");
										ontime = ontime.replace(rs, "");
										offtime = offtime.replace(rs, "");
										var zqxhweek = [];
										$('input[name=zqxh]:checked').each(function() {

											zqxhweek.push($(this).val());

										});

	var json = {"serviceCode":"1025",
		"uId": uid,
"eqId": eqId,
"citIds": citId,
"type": Type,
"weeks": zqxhweek.toString(),
"startTime": stime,
"endTime": etime,
"openLength": ontime,
"closeLength": offtime

}
return json;
}               
                            



}
});
    		
            		
            	})
            	
            	
            	
            	
            	
            	
            	
            	
            	
       } else if (state=="9") {
       	Type="D";
       	
       	$("#ljxhdiv").hide();
            	$("#zqdsdiv").hide();
            	$("#dcdsdiv").hide();
            	$("#zqxhdiv").hide();
            	$("#xhdsdiv").show();
       	$("#xhds").click(function(){
       		
       	  $.ajax({
					type: "post",
					url: "http://localhost:8080/ZYun/HttpService.do",
					contentType: "application/json; charset=utf-8",
					async: true,
					data: JSON.stringify(getData()),
					dataType: 'json',
					success: function(response) {
						console.log(response)
                        this.eqObject = response;
						this.eqType = response.eqType;
						var citId = "";
						var citDdTime1 = "";
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									
								}
							}else{
								list2[i] = cit;
							}
						}
                            
                         $.ajax({
										type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(a()),
										dataType: 'json',
										success: function(response) {
											console.log(response)
										if(response.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}	
							
							
							initTree()
							if(count==num){
								console.log("放开");
count = 0;
num = 0;
ajaxFlag = 0;

}

}
});

function a() {
var stime = $("#xhdsstime").val();
										var etime = $("#xhdsetime").val();
										var rs = new RegExp(":", "g");

										etime = etime.replace(rs, "");
										stime = stime.replace(rs, "");

										var xhdsweek = [];
										$('input[name=xhds]:checked').each(function() {

											xhdsweek.push($(this).val());

										});

	var json = {"serviceCode":"1025",
		"uId": uid,
"eqId": eqId,
"citIds": citId,
"type": Type,
"weeks": xhdsweek.toString(),
"startTime": stime,
"endTime": etime

}
return json;
}               
                            



}
});
      		
       	})
       	
       } else if (state=="12"){
       	 
       
       	 
       	 function a() {
       	 	
     var json = {"serviceCode":"1026",
		"uId": uid,
        "eqId": eqId
            }
return json;
}  
       	
       	        $.ajax({
						type: "post",
										url: "http://localhost:8080/ZYun/HttpService.do",
										contentType: "application/json; charset=utf-8",
										async: true,
										data: JSON.stringify(a()),
										dataType: 'json',
										success: function(response) {
											console.log(response);
										if(response.respCode=="0000"){
											
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
									
								}
								
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}	
							
							
							initTree()
							if(count==num){
								console.log("放开");
                              count = 0;
                               num = 0;
                               ajaxFlag = 0;
}

}
});
     	
       	
       	
       	
       	
       	
       	
       	
       	
       	
       }

},
  	
  	
  	
  	
  	
	  //1 全开   2全关   3开    4关    5点动
	  getAjax(state,no,node){
		  count ++;
		  console.log(node);
		  if(state==1||state==2){
			  var citState ;
			  if(state==1){
				  citState=1;
			  }
			  if(state==2){
				  citState=0;
			  }
			  const history = window.sessionStorage;
				var uid = history.getItem("user");
				var eqId = node.tags[0].eqId;
				
				this.$http.post('/ZYun/HttpService.do', {
					"serviceCode":"1020",
					"uId":uid,
					eqId:eqId,
					citState:citState
				})
				.then((response) => {
					if(response.data.respCode=="0000"){
						var str = node.text;
						if(str.indexOf("<img")==-1){
							node.text = str+"<img src=\"/static/img/icon11.png\" />";	
						}else{
							str = str.substring(0,str.indexOf("<img"));
							node.text = str+"<img src=\"/static/img/icon11.png\" />";
						}
					}else{
						var str = node.text;
						if(str.indexOf("<img")==-1){
							node.text = str+"<img src=\"/static/img/icon12.png\" />";	
						}else{
							str = str.substring(0,str.indexOf("<img"));
							node.text = str+"<img src=\"/static/img/icon12.png\" />";
						}
						
					}
					initTree()
					if(count==num){
						console.log("放开");
						count = 0;
						num = 0;
						ajaxFlag =0;
					}
				})
				.catch((response) =>{

				});
		  }else{

			  const history = window.sessionStorage;
				var uid = history.getItem("user");
				var eqId = node.tags[0].eqId;
				
				
				this.$http.post('/ZYun/HttpService.do', {
					"serviceCode":"1018",
					"uId":uid,
					eqId:eqId
				})
				.then((response) => {
					if(response.data.respCode=="0000"){
						this.eqObject = response.data;
						this.eqType = response.data.eqType;
						var citId = "";
						var citDdTime1 = "";
						var citState = "";
						if(state == 3){
							citState = "1";
						}
						if(state == 4){
							citState = "0";
						}
						if(state == 5){
							citState = "2";
						}
						var list1 = {};
						var list2 = {};
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							//如果是电路
							if(word1 == "0"){
								list1[i] = cit;
								if(word2==no){
									citId = cit.citId;
									citDdTime1 = cit.citDdTime;
								}
							}else{
								list2[i] = cit;
							}
						}
						
						var data = {
							"serviceCode":"1019",
							"uId":uid,
							eqId:eqId,
							citId:citId,
							citState:citState,
							citDdTime:citDdTime1
						}
						this.$http.post('/ZYun/HttpService.do', data)
						.then((response) => {
							if(response.data.respCode=="0000"){
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon11.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon11.png\" />";
								}
							}else{
								var str = node.text;
								if(str.indexOf("<img")==-1){
									node.text = str+"<img src=\"/static/img/icon12.png\" />";	
								}else{
									str = str.substring(0,str.indexOf("<img"));
									node.text = str+"<img src=\"/static/img/icon12.png\" />";
								}
							}
							initTree()
							if(count==num){
								console.log("放开");
								count = 0;
								num = 0;
								ajaxFlag =0;
							}
						})
						.catch((response) =>{
							console.log(response);
						});
					}else{

					}
					
				})
				.catch((response) =>{
					
					console.log(response);
				});
		  }
		  	
	  },
	  
	  gett(state,no){
	  	
	  	 if(ajaxFlag == 1 && state == (3 || 4 || 5 || 11) ){
			  console.log(num);
			  console.log(count);
			  console.log("该次请求未完成")
			return;
		  } 
		  
		  var checkedNodes = $checkableTree.treeview('getChecked');
		  if(checkedNodes.length==0){
			  return;
		  }
		  ajaxFlag = 1;
		  
		  if(checkedNodes[0].text=="全选"){
			  checkedNodes = checkedNodes.splice(1,checkedNodes.length-1) 
		  }
		  console.log(checkedNodes);
		 //列表下所有设备  nodes集合对象
		 var nodes = tree[0].nodes;
		 // num选中设备数量       checkedNodes选中所有设备  也是集合对象
		    num = checkedNodes.length;
		   
		  
			for(var i=0;i<nodes.length;i++){
				var flag1 = false;
				for(var j=0;j<checkedNodes.length;j++){
					
					 console.log("集合对象"+nodes);
					 console.log("集合对象下设备"+nodes[i]);
					 console.log(nodes[i].tags);
					 console.log(nodes[i].tags[0]);
					 console.log(checkedNodes[j].tags[0]);
					if(nodes[i].tags[0].eqId==checkedNodes[j].tags[0].eqId){
						flag1=true;
					}
				}
				if(flag1 == false){
					continue; 
				}
				if (state== "6" ||state=="7" ||state=="8" ||state=="9" ||state=="10" ||state=="11"||state=="12" ) {
					this.pichuli(state,no,nodes[i]);
				} else{
				this.getAjax(state,no,nodes[i]);
				}
				// arr[i]={
				// 	text: text,
				// 	href: '#child2',
				// 	tags: nodes[i].tags
				// }

			}
	  	
	  	
	  	
	  },
	  //(1,0,1)或者(1,0,2)
	  
	  get(state,no,mse){
          if(mse == "1" && state == "1"){
          	$("#kaiqi").attr("src", "/static/img/qktanqi.png");
          	
          	
          
		  if(ajaxFlag == 1){
			  console.log(num);
			  console.log(count);
			  console.log("重复")
				return;
		  } 
		  var checkedNodes = $checkableTree.treeview('getChecked');
		  if(checkedNodes.length==0){
			  return;
		  }
		  ajaxFlag = 1;
		  
		  if(checkedNodes[0].text=="全选"){
			  checkedNodes = checkedNodes.splice(1,checkedNodes.length-1) 
		  }
		  console.log(checkedNodes);
		  var nodes = tree[0].nodes;
		 //选中设备数量
		 num = checkedNodes.length;
		      // nodes.length 列表中设备数量
			for(var i=0;i<nodes.length;i++){
				var flag1 = false;
				for(var j=0;j<checkedNodes.length;j++){
					if(nodes[i].tags[0].eqId==checkedNodes[j].tags[0].eqId){
						flag1=true;
					}
				}
				if(flag1 == false){
					continue; 
				}
				this.getAjax(state,no,nodes[i]);
				// arr[i]={
				// 	text: text,
				// 	href: '#child2',
				// 	tags: nodes[i].tags
				// }

			}
	 
	  } else if (mse == "2" && state == "1"){$("#kaiqi").attr("src", "/static/img/quankailv.png")} 
	  
	  
	  
	  },
	  //(2,0,1)(2,0,2)
	  out(state,no,mse){
       if (mse == "1" && state == "2"){
          	$("#guanbi").attr("src", "/static/img/qgtanqi.png");
          	
          	
          
		  if(ajaxFlag == 1){
			  console.log(num);
			  console.log(count);
			  console.log("重复")
				return;
		  } 
		  var checkedNodes = $checkableTree.treeview('getChecked');
		  if(checkedNodes.length==0){
			  return;
		  }
		  ajaxFlag = 1;
		  
		  if(checkedNodes[0].text=="全选"){
			  checkedNodes = checkedNodes.splice(1,checkedNodes.length-1) 
		  }
		  console.log(checkedNodes);
		  var nodes = tree[0].nodes;
		  num = checkedNodes.length;
		  
			for(var i=0;i<nodes.length;i++){
				var flag1 = false;
				for(var j=0;j<checkedNodes.length;j++){
					if(nodes[i].tags[0].eqId==checkedNodes[j].tags[0].eqId){
						flag1=true;
					}
				}
				if(flag1 == false){
					continue; 
				}
				this.getAjax(state,no,nodes[i]);
				// arr[i]={
				// 	text: text,
				// 	href: '#child2',
				// 	tags: nodes[i].tags
				// }

			}
	 
	  }else if(mse == "2" && state == "2"){$("#guanbi").attr("src", "/static/img/quankaihong.png")}
	  },
	  
	  getEqList(eqType,pageSize){
		  $("#eq1").removeClass("active");
		  $("#eq2").removeClass("active");
		  $("#eq3").removeClass("active");
		  $("#eq4").removeClass("active");
          $("#eq5").removeClass("active");
		  $("#eq6").removeClass("active");
		  $("#eq7").removeClass("active");
		   $("#eq8").removeClass("active");
		    $("#eq9").removeClass("active");
		     $("#eq10").removeClass("active");
		  $("#eq11").removeClass("active");
	      $("#eq"+eqType).addClass("active");
	      $("#ljxhdiv").hide();
	      $("#zqdsdiv").hide();
	      $("#zqxhdiv").hide();
	      $("#dcdsdiv").hide();
	      $("#xhdsdiv").hide();
	      
	      
		  this.pageSize = pageSize;
		  this.eqType = eqType;
		  const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:eqType
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
			this.eqList = response.data.eqList;
		   
			var arr = new Array();
			
			for(var i=0;i<this.eqList.length;i++){
				if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 	
				 } else{
				 	ss="———在线";
				 }
				//设备名称
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			} else if (response.data.respCode=="9999"){
				
			     var arr = new Array();
			  tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
				
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
	  },
	getEqListPage(pageSize){
			console.log(pageSize)
			if(pageSize<1){
				pageSize=1;
			}
			var page = this.totoCount/this.pageNum+1;
			console.log(page)
			if(pageSize>page){
				return;
			}
			this.pageSize=pageSize;
		  $("#eq1").removeClass("active");
		  $("#eq2").removeClass("active");
		  $("#eq3").removeClass("active");
		  $("#eq4").removeClass("active");
           $("#eq5").removeClass("active");
	      $("#eq6").removeClass("active");
		  $("#eq7").removeClass("active");
		  $("#eq8").removeClass("active");
		    $("#eq9").removeClass("active");
		     $("#eq10").removeClass("active");
          $("#eq11").removeClass("active");
		  $("#eq"+this.eqType).addClass("active");
		  const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
			//当前页
			pageSize:pageSize,
			//当前页设备数
			pageNum:this.pageNum,
			eqType:this.eqType
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
			this.eqList = response.data.eqList;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
	  },
	  clickimg:function(type){
			if(type == "1"){
					$("#button2").attr("src","/static/img/anniu_4_h_a.png");
					var self = this;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					var data = {};
					var value = "0";
					if(this.clickFlag == false){
						value = "1";
					}
					data = {
						"serviceCode":"1019",
						"uId":uid,
						eqId:this.eqId,
						citId:this.list1[0].citId,
						citState:value,
						citDdTime:this.citDdTime1
					}
				this.$http.post('/ZYun/HttpService.do', data)
					.then((response) => {
						if(response.data.respCode=="0000"){
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function(){
								self.alert3 = false;
								},1000);
							
							this.clickEq(this.eqObject);
						}else{
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
							},1000);
							console.log(response);
						}
					})
					.catch((response) =>{
						console.log(response);
					});
				}else{
					$("#button2").attr("src","/static/img/anniu_4_h_b.png");
				}
		},
	  changeimg:function(type){
			if(this.clickFlag == true){
				if(type == "1"){
					$("#button1").attr("src","/static/img/anniu_4_l_a.png");
					var self = this;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					var data = {};
					var value = "0";
					if(this.clickFlag == false){
						value = "1";
					}
					data = {
						"serviceCode":"1019",
						"uId":uid,
						eqId:this.eqId,
						citId:this.list1[0].citId,
						citState:value
					}
					
				this.$http.post('/ZYun/HttpService.do', data)
					.then((response) => {
						if(response.data.respCode=="0000"){
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function(){
								self.alert3 = false;
								},1000);
							window.setTimeout(function(){
								if(self.clickFlag == false){
									self.clickFlag = true;
								}else{
									self.clickFlag = false;
								}
							},100);
							this.clickEq(this.eqObject);
						}else{
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
							},1000);
							console.log(response);
						}
					})
					.catch((response) =>{
						console.log(response);
					});
				
					
				}else{
					$("#button1").attr("src","/static/img/anniu_4_l_b.png");
				}
			}
			if(this.clickFlag == false){
				if(type == "1"){
					$("#button2").attr("src","/static/img/anniu_4_h_a.png");
					var self = this;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					var data = {};
					var value = "0";
					if(this.clickFlag == false){
						value = "1";
					}
					data = {
						"serviceCode":"1019",
						"uId":uid,
						eqId:this.eqId,
						citId:this.list1[0].citId,
						citState:value
					}
					
				this.$http.post('/ZYun/HttpService.do', data)
					.then((response) => {
						if(response.data.respCode=="0000"){
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function(){
								self.alert3 = false;
								},1000);
							window.setTimeout(function(){
								if(self.clickFlag == false){
									self.clickFlag = true;
								}else{
									self.clickFlag = false;
								}
							},100);
							this.clickEq(this.eqObject);
						}else{
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
							},1000);
							console.log(response);
						}
					})
					.catch((response) =>{
						console.log(response);
					});
				}else{
					$("#button2").attr("src","/static/img/anniu_4_h_b.png");
				}
			}
			
		}
  },
  mounted: function () {
  	 jeDate("#dcdsstime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#riqi", {
				isinitVal: true,
				festival: true,
				format: 'YYYY/MM/DD'
			});
			jeDate("#zqdsstime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#stime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#etime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#ontime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#offtime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#xhdsstime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#xhdsetime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#ljxhontime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
			jeDate("#ljxhofftime", {
				isinitVal: true,
				festival: true,
				format: "hh:mm:ss"
			});
		const history = window.sessionStorage;
			var uid = history.getItem("user");
			var parent = history.getItem("parent");
			this.parent = parent;
			
			this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:this.eqType
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len3 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		
		
		
			
			this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"1"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len1 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
			
	this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"2"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len2 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				       
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"4"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len4 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"5"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len5 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"6"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len6 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"7"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len7 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"8"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len8 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"9"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len9 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"10"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len10 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		this.$http.post('/ZYun/HttpService.do', {
			"serviceCode":"1012",
			"uId":uid,
            eqType:"11"
			})
		.then((response) => {
			if(response.data.respCode=="0000"){
				
			this.eqList = response.data.eqList;
			 this.len11 = this.eqList.length;
			var arr = new Array();
			for(var i=0;i<this.eqList.length;i++){
				 if(this.eqList[i].eqState == 0){
				 	var ss = "———离线";
				 } else{
				 	ss="———在线";
				 }
				 
				var text = this.eqList[i].eqName;
				arr[i]={
					text: text+ss,
					href: '#child2',
					tags: [this.eqList[i]]
				}
			}
			tree = [
				{
					text: '全选',
					href: '#parent1',
					tags: ['4'],
					nodes: arr
				}
			];
			this.totoCount = response.data.totoCount;
			initTree();
			}else{
			console.log(response);
			}
		})
		.catch((response) =>{
			console.log(response);
		});
		
		
		
		
		
		
		
  },
  components: {
	  headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
  }
}
</script>

 Add "scoped" attribute to limit CSS to this component only 
<style scoped src="../../../static/css/mass.css">

</style>


// WEBPACK FOOTER //
// src/components/send/send.vue